import errorHandler from "../../handlers/errorHandler";
import successHandler from "../../handlers/successHandler";
import { thirdPartyWebHooksService } from '../../services/thirdPartyWebhooks.service';
import thirdPartyWebhookType from "./thirdPartyWebhookTypes";

/**
 * Get my Webhooks
 **/

export const getMyThirdPartyWebhooks = (business_id) => async (dispatch) => {
  try {
    dispatch({ type: thirdPartyWebhookType["LOADING"], payLoad: true });
    const response = await thirdPartyWebHooksService.getMyThirdPartyWebhooks(
      business_id
    );
    dispatch({ type: thirdPartyWebhookType["LOADING"], payLoad: false });
    dispatch({
      type: thirdPartyWebhookType["MY_THIRD_PARTY_WEBHOOKS"],
      payLoad: response,
    });
  } catch (error) {
    dispatch({ type: thirdPartyWebhookType["LOADING"], payLoad: false });
    errorHandler(error, true);
  }
};

/**
 * createThirdPartyWebhook
 **/

export const createThirdPartyWebhook = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: thirdPartyWebhookType["CREATING"], payLoad: true });
    const response = await thirdPartyWebHooksService.createThirdPartyWebhook(
      payLoad
    );
    dispatch({ type: thirdPartyWebhookType["CREATING"], payLoad: false });
    dispatch({
      type: thirdPartyWebhookType["CREATE_THIRD_PARTY_WEBHOOK"],
      payLoad: response,
    });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({ type: thirdPartyWebhookType["CREATING"], payLoad: false });
    errorHandler(error, true);
  }
};


/**
 * deleteThirdPartyWebhook
 **/

export const deleteThirdPartyWebhook = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: thirdPartyWebhookType["DELETING"], payLoad: true });
    const response = await thirdPartyWebHooksService.deleteThirdPartyWebhook(
      payLoad
    );
    dispatch({ type: thirdPartyWebhookType["DELETING"], payLoad: false });
    dispatch({
      type: thirdPartyWebhookType["DELETE_THIRD_PARTY_WEBHOOK"],
      payLoad: response,
    });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({ type: thirdPartyWebhookType["DELETING"], payLoad: false });
    errorHandler(error, true);
  }
};